export default __webpack_public_path__ + "static/media/csharp.57e28cdd.svg";